'use client';

import { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import BenefitsSection from './BenefitsSection';
import OpenPositionsSection from './OpenPositionsSection';
import TeamCultureSection from './TeamCultureSection';
import FAQSection from './FAQSection';
import CTASection from './CTASection';
import ApplicationForm from './ApplicationForm';

const CareersInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [showApplicationForm, setShowApplicationForm] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState<number | undefined>(undefined);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <div className="h-96 bg-primary animate-pulse" />
        <div className="container mx-auto px-4 py-16">
          <div className="space-y-8">
            <div className="h-8 bg-surface rounded animate-pulse" />
            <div className="h-8 bg-surface rounded animate-pulse" />
            <div className="h-8 bg-surface rounded animate-pulse" />
          </div>
        </div>
      </div>
    );
  }

  const handleApply = (positionId?: number) => {
    setSelectedPosition(positionId);
    setShowApplicationForm(true);
  };

  const handleCloseForm = () => {
    setShowApplicationForm(false);
    setSelectedPosition(undefined);
  };

  return (
    <>
      <HeroSection />
      <BenefitsSection />
      <OpenPositionsSection onApply={handleApply} />
      <TeamCultureSection />
      <FAQSection />
      <CTASection onApply={() => handleApply()} />
      {showApplicationForm && (
        <ApplicationForm
          selectedPosition={selectedPosition}
          onClose={handleCloseForm}
        />
      )}
    </>
  );
};

export default CareersInteractive;